module.exports = __webpack_public_path__ + "img/9_116.fcc7041e.png";